export default __webpack_public_path__ + "static/media/YAS0840.34I-37996_-24617_0.eb5459c3.jpg";